var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9843 16.4433C45.0981 11.0558 42.5106 6.1254 37.2264 3.35591C33.0014 1.1382 28.3195 0.052656 23.6053 0.00625602C19.1235 -0.0332106 14.9632 0.0153227 10.5947 3.26097C0.0867455 11.0741 -3.36008 27.7033 3.70317 39.507C4.66541 41.1151 5.97943 42.2957 7.45517 43.4368C11.8318 46.7977 16.8674 47.8054 24.1208 47.8913C27.5756 47.6438 32.6779 46.2063 37.6568 44.294C38.2552 44.0555 38.8172 43.4854 39.1972 42.9335C40.9762 40.353 42.9573 37.8504 44.3663 35.0707C47.3157 29.2072 49.305 23.0971 46.9843 16.4433ZM44.708 26.7703C42.9472 32.0243 40.208 36.5546 37.1333 41.011C36.8463 41.4194 36.3995 41.8197 35.9426 41.9814C31.3274 43.5804 26.6799 45.0561 21.7413 45.1118C17.0574 45.0562 12.7354 43.9798 8.9854 41.0576C7.94029 40.249 6.95981 39.4404 6.24621 38.2871C0.173466 28.4361 2.094 14.1772 10.5097 7.19078C14.4415 3.927 18.8283 1.87015 24.1672 2.76455C27.6037 3.33767 30.9736 4.10684 34.3435 5.07921C41.2997 7.08657 46.8893 20.2416 44.708 26.7703Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5339 11.9594C32.486 13.9779 30.422 15.9863 28.4045 18.0331C27.0239 19.4421 26.0434 21.6203 23.3973 20.3367C23.1607 20.2214 22.6553 20.3841 22.4269 20.5924C21.3696 21.5445 20.5711 20.9158 19.6676 20.3083C17.8684 19.0883 16.0207 17.938 14.165 16.7857C13.4716 16.3481 12.6327 16.0711 12.0524 16.8615C11.4824 17.6236 11.8705 18.4323 12.5074 18.9366C13.4595 19.6886 14.5086 20.3456 15.5558 20.9642C17.5046 22.1154 19.3987 23.1526 19.9243 25.7705C20.2276 27.2856 21.4364 28.5217 23.3791 28.6642C25.0247 28.4267 26.654 27.7607 27.0341 25.9221C27.5759 23.3052 29.0698 21.3545 30.8205 19.527C32.6965 17.5843 34.6776 15.7477 36.5535 13.8071C37.1701 13.1783 37.7038 12.2828 36.8284 11.5227C36.0095 10.799 35.201 11.3034 34.5339 11.9594Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8627 25.3237C40.8148 25.2388 41.8519 25.077 41.9288 23.848C42.0056 22.8291 41.1868 22.6301 40.2549 22.5349C39.3978 22.6582 38.4274 22.8584 38.3325 24.0673C38.2557 25.0861 39.0177 25.3904 39.8627 25.3237Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0845 9.12437C24.0932 9.14251 24.265 8.27637 24.3217 7.41013C24.2651 6.55296 24.1883 5.61099 23.0259 5.51595C21.999 5.42998 21.6857 6.22038 21.6574 7.04821C21.6269 8.04789 21.8008 9.10411 23.0845 9.12437Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3404 38.6012C22.4064 38.6316 22.1011 39.3544 22.0264 40.1721C22.0365 41.0666 22.37 41.7529 23.3222 41.7337C24.2743 41.7136 24.5875 40.9535 24.624 40.1347C24.6646 39.2785 24.3209 38.5547 23.3404 38.6012Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75979 22.1732C5.93301 22.154 5.13045 22.3734 5.02741 23.3538C4.92224 24.3424 5.59744 24.6961 6.48491 24.7427C7.34816 24.7052 8.04352 24.4486 8.07381 23.4387C8.09205 22.5634 7.54016 22.1915 6.75979 22.1732Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/TimeIcon.0bd2ca7204a3171836b10dfa137ede03.svg";
export { ForwardRef as ReactComponent };